import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { useUser } from '@/providers';

import ConsolidatedBillingRequestForm from './consolidated/ConsolidatedBillingRequestForm';
import ConsolidatedBillingRequestPending from './consolidated/ConsolidatedBillingRequestPending';
import ConsolidatedBillingAdmin from './consolidated/ConsolidatedBillingAdmin';

const ConsolidatedBillingForm = () => {
  const user = useUser();

  const hasBillingRequests =
    user.billing_link_requests && user.billing_link_requests.length;
  const hasLinkedAccounts =
    user.billing_linked_accounts && user.billing_linked_accounts.length;
  const hasRequestedEmail = user.requested_billing_email;

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant='h4' component='h2' align='center' gutterBottom>
        Consolidated Billing
      </Typography>
      <Typography paragraph>
        Consolidated billing allows multiple {import.meta.env.VITE_ORG_NAME}{' '}
        users to share the same credit pool that is managed by and only visible
        to a central account.
      </Typography>
      <Box>
        {hasBillingRequests || hasLinkedAccounts ? (
          <ConsolidatedBillingAdmin />
        ) : hasRequestedEmail ? (
          <ConsolidatedBillingRequestPending />
        ) : (
          <ConsolidatedBillingRequestForm />
        )}
      </Box>
    </Paper>
  );
};

export default ConsolidatedBillingForm;
